export default __webpack_public_path__ + "static/media/ExploreArrow.e71ff0b0.svg";